import { useRef } from 'react';
import { useIntl } from 'react-intl';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { PageType } from '../../../shared/enums/pageType';
import { type FragmentContext, type RecommendationOptions } from '../../../shared/types';
import { TrackingCategory, TrackingListName } from '../../enums';
import { useLastSeenProducts } from '../../hooks/useLastSeenProducts';
import { lastSeenSliderMessages as messages } from '../../i18n';
import { Headlines } from '../Headlines';
import { ProductSlider } from '../ProductSlider';

const LastSeenProductSlider = ({
    lazyLoad,
    options,
    virtualSlide = true,
    wishlist,
}: {
    readonly lazyLoad: boolean;
    readonly options?: RecommendationOptions;
    readonly virtualSlide?: boolean;
    readonly wishlist?: string[];
}): JSX.Element | null => {
    const intl = useIntl();
    const { getLastSeenProductIdsStorage, pageType } = useFragmentContext<FragmentContext>();

    const productIds = useRef(getLastSeenProductIdsStorage().get()).current;

    const { loading, products } = useLastSeenProducts(productIds);

    const productList = (pageType === PageType.Wishlist ? products.slice(0, 4) : products) ?? [];

    return productIds.length ? (
        <>
            <Headlines headline={options?.headline} subHeadline={options?.subHeadline} />
            <ProductSlider
                productItems={productList}
                title={options?.productSliderTitle ?? intl.formatMessage(messages.lastSeenProducts)}
                trackingCategory={TrackingCategory.ProductList}
                trackingListName={TrackingListName.LastSeen}
                dataTestId="last-seen-slider"
                lazyLoad={lazyLoad}
                virtualSlide={virtualSlide}
                showSkeletons={loading}
                isExpandableTile={options?.productTile?.expandable}
                wishlist={wishlist}
            />
        </>
    ) : null;
};

export { LastSeenProductSlider };
